/**
 * Calculate sizes needed to operate with a hex
 * more info: https://www.redblobgames.com/grids/hexagons/#basics
 * @param width -
 */
export const calculateHexSizeBasedOnWidth = (width: number) => {
  // from the center to the point at the top (horizontal half)
  const hexSize = width / Math.sqrt(3);
  // whole height: aka from the point at the bottom to the point at the top
  const height = hexSize * 2;
  // at quarter of the height are the points that are not the top nor the bottom one.
  const hexQuarterHeight = height / 4;
  // horizontal half
  const hexRadius = width / 2;

  return { hexSize, height, hexQuarterHeight, hexRadius };
};

export const calculateHexSizeBasedOnHeight = (height: number) => {
  // from the center to the point at the top (horizontal half)
  const hexSize = height / 2;
  // whole width
  const width = Math.sqrt(3) * hexSize;
  // at quarter of the height are the points that are not the top nor the bottom one.
  const hexQuarterHeight = height / 4;
  // horizontal half
  const hexRadius = width / 2;

  return { hexSize, width, hexQuarterHeight, hexRadius };
};
